module.exports = __webpack_public_path__ + "static/cs-5693d4049b492b5ab6f21dbe73b955b2.png";